import { useLang } from '@/i18n';
import EfBanner from '@elem/ui/ef-banner';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('power_kits_48v_system');
    return (
        <div className={styles.TheComp}>
            <EfBanner
                pc="https://websiteoss.ecoflow.com/upload/image/1724921773023/pc_app%20control.jpg"
                pad="https://websiteoss.ecoflow.com/upload/image/1724921773023/pc_app%20control.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1724921789249/m_app%20control.jpg"
                label={t('K_label')}
                title={t('K_title')}
                desc={t('K_desc')}
            />
        </div>
    );
}
